'use strict';

import request from 'superagent';
import api from './core';

export function create(exchange) {
    return api.forwardResult(
        api.prepare(request.post(api.url('/exchanges/'))).send(exchange),
        'id'
    );
}

export function fetchPage(args) {
    return api.prepare(request.get(api.url('/exchanges/'))).query(args);
}

export function list(args) {
    return api.forwardResult(fetchPage(args), 'results');
}



// WEBPACK FOOTER //
// ./src/api/exchanges.js